import { database } from './';

export function createUserRoomLink(userId: string, roomId: string) {
    const id = database.ref('userRoomLinks').push().key;
    const userRoomLink = {
        id,
        userId,
        roomId,
    };
    return database
        .ref(`userRoomLinks/${id}`)
        .set(userRoomLink)
        .then(() => userRoomLink);
}
